import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { interval, Subscription } from 'rxjs';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { api } from 'src/app/@shared/services/api';
import { CommonService } from 'src/app/@shared/services/common.service';
import { PusherService } from 'src/app/@shared/services/pusher.service';
import { SharedService } from 'src/app/@shared/services/shared.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent extends BaseClass<any> implements OnInit {

  public menu: any[] = [];
  public data: any;
  public marketData: any;
  public inPlay: any[] = [];
  public oodsList: any[] = [];
  public oddsLisDis: any = {};
  public showLoader = true;
  public baseUrl: any = '';
  public marketsReq: any[] = [];
  public newOddsEnable: boolean = false;
  public exposLisDis: any = {};
  public raceList: any;
  public listRes: any;
  public topBanners: any[] = [];

  constructor(public _shared: SharedService,
    public service: WebserviceService,
    public _common: CommonService,
    public router: Router,
    public _pusher: PusherService) {
    super();

    const sub1 = this._pusher.eventListUpdate().subscribe(res => {
      // console.log(res);

      if (res?.op == 'UPDATE') {
        // console.log("pusher");

        this.getListData();
      }
    });
    this.subs.push(sub1);

    //emit value in sequence every given second\
    const sub2 = interval(this.env.pollers.listOddsData).subscribe(val => {
      if (this.baseUrl != '') {
        if (this.newOddsEnable == true) {
          this.getOddsNew(this.marketsReq, this.data, this.marketData);
        } else {
          this.getOdds(this.marketsReq, this.data, true);
        }
      }
    });
    this.subs.push(sub2);
  }

  width: number = window.innerWidth;
  mobileWidth: number = 768;

  onWindowResize(event: any) {
    this.width = event.target.innerWidth;
    // console.log(`${this.width}`);
  }

  ngOnInit(): void {
    this.topBanners = this.genListBanner();
    this.menu = (localStorage.getItem(`${this.env.panel}menu`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}menu`) as any) : [];
    this.getListData();
  }


  getServices(): IbaseService<any> {
    return this.service;
  }

  getListData() {
    this.getServices().Get(`${this.env.baseUrl + this.api.eventListNew}`).subscribe(
      (res) => {
        if (res.status == true) {

          this.listRes = res.data;
          // sidemenu content
          this.setLocalItem('sideMenu', res.data.events);
          this._shared.emitSideMenu(res.data.events);
          this.setRaceSideMenu(7, res.data.races);
          this.setRaceSideMenu(4339, res.data.races);
          this.raceList = res.data.races

          this.featuredEvents(res.data.events);
          res.data.events.forEach((element: any) => {
            element["runner"] = element.name.split(" v ");
          });

          this.commonLogics(res, res.data.events);
        }
      },
      (err) => {
        console.log(err);
      });
  }
  commonLogics(res: any, events: any) {
    this.baseUrl = (res.data.connect_odds_hub == true) ? `https://${res.data.odds_hub}` : this.env.baseUrl;
    events = this._common.UTC_to_Local_timeZone(events);
    this.marketsReq = this.genMarketReq(events);

    this.marketData = res?.data;
    this.data = events;
    this.arrangeData();
    this.showLoader = false;

    // this.openFilteredTab();

    if (res?.data?.bm_new_enable == true && res?.data?.fancy_new_enable == true && res?.data?.odds_new_enable == true) {
      this.newOddsEnable = true;
      this.getOddsNew(this.marketsReq, this.data, res.data);
    } else {
      this.newOddsEnable = false;
      this.getOdds(this.marketsReq, this.data, res.data);
    }
    this.getExposure(this.marketsReq, this.data);
  }
  setRaceSideMenu(id: any, items: any) {
    let dt = items.filter((s: any) => { return Number(s.event_type_id) == Number(id) });
    this.setLocalItem(`sideRaceMenu${id}`, dt);
    this._shared.emitSideMenu(dt);
  }

  getOdds(req: any, items: any, resData: any) {
    // let baseUrl = (resData?.connect_odds_hub == true) ? `https://${resData?.odds_hub}` : this.env.baseUrl;
    this.getServices().Post(`${this.baseUrl + this.api.odds}`, req).subscribe(
      (res) => {

        res = this._common.string_to_JSON(res);
        this.oodsList = this._common.compareData(res, this.oodsList);
        this.oddsLisDis = Object.assign({}, ...this.oodsList.map((elt: any) => ({ [elt.marketId ? elt.marketId : elt.market_id]: elt })));

        this.data = items;

        this.arrangeData();
        this.showLoader = false;
      },
      (err) => {
        console.log(err);
      });
  }

  oddsLisDisNew: any = {};
  getOddsNew(req: any, items: any, resData: any) {
    this.getServices().Post(`${this.baseUrl + this.api.oddsNew}`, req).subscribe(
      (res) => {
        res = this._common.pipe_string_to_JSON(res);

        let resOdds: any = this._common.arrangeGetMarketNewData(res, resData);
        if (this.oddsLisDisNew.length == 0) {
          this.oddsLisDisNew = resOdds;
        } else {
          let newOddsLD = resOdds;
          Object.keys(newOddsLD).forEach(key => {
            if (Object.keys(this.oddsLisDisNew).includes(key)) {
              delete this.oddsLisDisNew[key];
            }
          });
          this.oddsLisDisNew = { ...this.oddsLisDisNew, ...newOddsLD }
        }
        this.oddsLisDis = this.oddsLisDisNew;
        this.data = items;

        this.arrangeData();
        this.showLoader = false;
      },
      (err) => {
        console.log(err);
      });
  }

  getExposure(req: any, items: any) {
    this.getServices().Post(`${this.env.baseUrl + this.api.exposure}`, req).subscribe(
      (res) => {
        if (res.status == true) {
          res = res.data.exposes;
          res = this._common.string_to_JSON(res);

          res.forEach((element: any) => {
            element["expo"] = element.reduce((a: any, b: any) => { return (b.expose < a.expose) ? b : a; });
            // let temp = Object.assign({}, ...element.map((elt: any) => ({ [elt.selection_id]: elt })));
            this.exposLisDis[element[0]?.marketId ? element[0]?.marketId : element[0]?.market_id] = element;
          });

          items.forEach((dt: any) => {
            res.forEach((element: any) => {
              element.forEach((expo: any, i: any) => {
                if (expo.event_id == dt.event_id) {
                  element["exposure"] = expo.expose;
                }
              });
            });
          });

          // items = this.setExposeData(items, res);
          // this.data = items;
          // console.log(res);
        }
      },
      (err) => {
        console.log(err);
      });
  }

  arrangeData() {
    const grouped = this._common.groupBy(this.data, (dat: any) => dat.event_type_id);
    this.menu.forEach((sm: any) => {
      sm["tabData"] = grouped.get(sm.id) ? grouped.get(sm.id) : [];
    });
    // console.log(this.menu);


    const groupedInPlay = this._common.groupBy(this.data, (dat: any) => dat.in_play);
    let inPlayDt = groupedInPlay.get(1) ? groupedInPlay.get(1) : [];


    const groupedInPlayCat = this._common.groupBy(inPlayDt, (dat: any) => dat.event_type_id);
    this.menu.forEach((sm: any, i) => {
      this.inPlay[i] = { name: sm.name, data: groupedInPlayCat.get(sm.id) ? groupedInPlayCat.get(sm.id) : [] };
    });



  }

  multiMarketIds: any[] = [];
  multiMarketUpdate(item: any, key: any) {
    // console.log(item);
    let url = (key == 'save') ? `${this.api.saveMultiMarket}/${item?.market_id}/${item?.event_id}/MATCH_ODDS/${this.data?.event?.event?.event_type_id}` : `${this.api.removeMultiMarket}/${item?.market_id}`;

    this.getServices().Get(`${this.env.baseUrl + this.api.multiMarket + url}`).subscribe(
      (res) => {
        if (res.status == true) {
          if (key == 'save') {
            this.multiMarketIds.push(item?.market_id)
          } else {
            // this.multiMarketIds = JSON.parse(res?.data?.multi)
            this.getListData();
          }
          // this.fancyRun = JSON.parse(res.data.position);
        }
      },
      (err) => {
        console.log(err)
      });
  }

  onSelect(data: any): void {
    this.setChangedTabData(data);
    // let urlArr = this.router.url.split(':')
    // let key = (urlArr.length > 1) ? urlArr[urlArr.length - 1] : '';
    // if (data.id == '99995' && key != '') {
    //   this.router.navigate(['/dashboard', `${data.id}:${key}`]);
    // } else {
    //   this.router.navigate(['/dashboard', data.id]);
    // }
  }
  setChangedTabData(data: any) {
    if (data.id == '99999') {
      this._shared.emitTabCasino(data);
    } else if (data.id == '99995') {
      this._shared.emitTabCasinoI(data);
    }
  }

  featuredEvents(data: any) {
    const grouped = this._common.groupBy(data, (dat: any) => dat.featured_event);
    let fetEvents = grouped.get(1) ? grouped.get(1) : [];
    localStorage.removeItem(`${this.env.panel}upcoming`);
    localStorage.setItem(`${this.env.panel}upcoming`, JSON.stringify(fetEvents))
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

  detailPage(e: any) {
    this.router.navigate(['/event/detail', e.event_id]);
  }

  ngOnDestroy() {
    this.subs.forEach((s) => s.unsubscribe());
  }

}
